var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { UuiSingleSelect, UuiSingleSelectOption } from "@aonunited/react";
import './AonSingleSelect.component.scss';
var AonSelect = function (_a) {
    var disabled = _a.disabled, label = _a.label, style = _a.style, required = _a.required, options = _a.options, defaultValue = _a.defaultValue, handelChecked = _a.handelChecked, selectedValue = _a.selectedValue, enableSearch = _a.enableSearch, onSearchValueChange = _a.onSearchValueChange, layout = _a.layout;
    var _b = useState([]), allOptions = _b[0], setAllOptions = _b[1];
    var HandleSelectSearch = function (event) {
        if (onSearchValueChange) {
            return onSearchValueChange();
        }
        else {
            console.log("event.target.selectedValue", event.detail);
            setAllOptions(function (prev) { return event.detail ?
                options.filter(function (data) { return data.label.toLowerCase().includes(event.detail.toLowerCase()); }) : options; });
        }
    };
    useEffect(function () {
        if (options.length) {
            setAllOptions(__spreadArray([], options, true));
        }
    }, [options]);
    var mainClass = "multiselect";
    if (layout === "TOP") {
        mainClass = mainClass + " " + "topView";
    }
    return (React.createElement("div", { className: "dropdownContainer", style: __assign({ width: 300 }, style) },
        label && required ? React.createElement("div", { style: { paddingBottom: "5px" } },
            React.createElement("span", null,
                label,
                React.createElement("span", { style: { color: "red" } }, "*"))) : label && React.createElement("div", { style: { paddingBottom: "5px" } },
            React.createElement("span", null, label)),
        React.createElement("div", { className: mainClass, style: { width: "100%" } },
            React.createElement(UuiSingleSelect, { disabled: disabled, enableSearch: enableSearch, onSearchChange: enableSearch ? HandleSelectSearch : undefined, defaultLabel: defaultValue, selectedValue: selectedValue, onSelectChange: handelChecked },
                React.createElement("div", { className: "multiselect-productContent" }, allOptions === null || allOptions === void 0 ? void 0 : allOptions.map(function (option, index) {
                    var value = option.value;
                    return (React.createElement(UuiSingleSelectOption, { className: "multiSelect-option", key: index, label: option.label, value: value }));
                }))))));
};
export { AonSelect };
